module.exports = "\n<app-navbar></app-navbar>\n\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/tejashree/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main